import React from "react";

const Header = () => {
  return (
    <header className="vertex-header slds-m-bottom_x-large">
      <div className="slds-grid slds-wrap slds-grid_vertical-align-center slds-gutters">
        {/* Logo */}
        <div className="slds-col slds-size_12-of-12 slds-large-size_3-of-12">
          <img className="vertex-header__logo" src="/Vertex-Logo.png" alt="Vertex" />
        </div>

        {/* Text */}
        <div className="slds-col slds-size_12-of-12 slds-large-size_9-of-12">
          <h1 className="vertex-header__title slds-text-heading_medium slds-m-bottom_x-small">
            Vertex Equipment Redeployment Website
          </h1>

          <p className="slds-text-body_regular slds-text-color_weak">
            To request an item for redeployment, submit a MyVertex Equipment Request ticket and
            include the Product # of the items you are requesting.
          </p>

          <p className="slds-text-body_regular slds-text-color_weak">
            Full instructions and process details can be found on Vnet{" "}
            <a className="vertex-header__link" href="https://vnet--simpplr.vf.force.com/apex/simpplr__app?u=/site/a0q1I000001RBixQAG/page/a0kRc00000QjUz3IAF" target="_blank" rel="noreferrer">
              here
            </a>
            .
          </p>
        </div>
      </div>
    </header>
  );
};

export default Header;
